import moment from 'moment';

import withOptions from 'utils/functions/withOptions.util';
import isDateWorthy from 'utils/predicates/time/isDateWorthy.util';

// TODO: move into a new file diff.util.js with all the same diffing function, like format.util.js
const timeDiffDays = withOptions(({ bgn, end }) =>
  isDateWorthy(bgn) && isDateWorthy(end) ? moment(end).diff(bgn, 'days') : NaN,
);

export default timeDiffDays;
